import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNavHeight } from '../utils/hooks';
import useIsEn from '../hooks/useIsEn';
var Nav = function (_a) {
    var _b = _a.close, close = _b === void 0 ? false : _b, title = _a.title, _c = _a.styleType, styleType = _c === void 0 ? 'black' : _c, className = _a.className;
    var h = useNavHeight();
    // <div className='relative flex pt-3 justify-center h-[44px]'>
    //     <div className='absolute left-3 top-1/2 transform translate-y-[-25%] w-[24px] h-[24px] bg-cover' onClick={close} style={{ backgroundImage: `url(${require('asset/imgs/back.png')})` }}></div>
    //     <div className='pt-[2px] font-abeezee text-white font-bold text-[18px]' dir='auto'>{_T('公会')}</div>
    // </div>
    var navigate = null;
    try {
        navigate = useNavigate();
    }
    catch (e) {
        console.log('Navigation not available');
    }
    var isEn = useIsEn();
    useEffect(function () { }, []);
    var goBack = function () {
        if (!close && navigate) {
            navigate(-1);
        }
        else {
            window.toFlutter.postMessage(JSON.stringify({
                method: 'closeWebView',
            }));
        }
    };
    var getImg = function () {
        return styleType === 'black'
            ? require('../asset/imgs/back3.png')
            : require('../asset/imgs/back.png');
    };
    return (_jsxs("div", { className: "w-full ".concat(className || ''), style: {
            // marginTop: `-${h}px`
            direction: isEn ? 'ltr' : 'rtl',
        }, children: [_jsx("div", { className: "w-full", style: {
                    height: "".concat(h, "px"),
                    backgroundColor: styleType === 'black' ? '#fff' : 'transparent',
                } }), _jsxs("div", { className: "".concat(styleType === 'black' ? 'bg-white' : 'transparent', " relative flex pt-3 justify-center h-[44px]"), children: [isEn ? (_jsx("div", { className: "absolute left-3 top-1/2 transform translate-y-[-40%] w-[24px] h-[24px] bg-cover", style: { backgroundImage: "url(".concat(getImg(), ")") }, onClick: goBack })) : (_jsx("div", { className: "rotate-180 absolute right-3 top-1/2 transform translate-y-[-40%] w-[24px] h-[24px] bg-cover", style: { backgroundImage: "url(".concat(getImg(), ")") }, onClick: goBack })), _jsx("div", { className: "text-center font-sans font-bold text-[18px] ".concat(styleType === 'black' ? 'text-[#333]' : 'text-[#fff]'), dir: "auto", children: title })] })] }));
};
export default Nav;
